import { Injectable } from '@angular/core';
import { BaseService } from '../../../shared/services/base.service';
import { AbstractControl, FormControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { ValidationService } from './../../../shared/services/validation.service';
import { ConsultationUrl } from '../../../shared/urls/consultation.url';
import { UserUrl } from '../../../shared/urls/user.url';
import { Utility } from '../../../common/utility';
import { MasterDataUrl } from '../../../shared/urls/master-data.urls';
@Injectable()
export class PopupSummaryTripInformationService {
    constructor(public baseService: BaseService) { }


    getTripInformation(consultationId) {
        const informationUrl = Utility.stringFormat(ConsultationUrl.GET_TRIP_INFORMATION, [consultationId]);
        return this.baseService.getData(informationUrl);
    }

    getTripInformationGroup(groupconsultationId) {
        const informationUrl = ConsultationUrl.GET_TRIP_INFORMATION_GROUP.replace('{groupConsultationId}', groupconsultationId);
        return this.baseService.getData(informationUrl);
    }

    getCountries() {
        const countryUrl = UserUrl.GET_USER_COUNTRY;
        return this.baseService.getData(countryUrl);
    }

    getCountryRegions(countryId) {
        const countryRegionUrl = UserUrl.GET_COUNTRY_REGION;
        return this.baseService.getData(countryRegionUrl, { countryId: countryId });
    }

    validateDateRange(fromDateControl, toDateControl, isFromDateActive) {
        if (ValidationService.isValidDate(fromDateControl) || ValidationService.isValidDate(toDateControl)) {
            return;
        }
        fromDateControl.value.setHours(0, 0, 0);
        toDateControl.value.setHours(0, 0, 0);
        // validate fromDate < toDate
        if (ValidationService.compareDate(fromDateControl, toDateControl) === 1) {
            if (isFromDateActive) {
                fromDateControl.setErrors({ 'invalidDateRangeTripInfo': true });
            } else {
                toDateControl.setErrors({ 'invalidDateRangeTripInfo': true });
            }
        } else {
            if (fromDateControl.value >= new Date()) {
                fromDateControl.setErrors(null);
            }
            if (toDateControl.value >= new Date()) {
                toDateControl.setErrors(null);
            }
        }
    }

    validateCurrentDate(isDataEntryMode): ValidatorFn {
        return function (c: FormControl) {
            if (isDataEntryMode === true) {
                return null;
            } else {
                if (!c.value) {
                    return null;
                } else if (Object.prototype.toString.call(c.value) !== '[object Date]' || isNaN(c.value.getTime())) {
                   // c.setValue(new Date(c.value));
                }
                const date = new Date();
                let currentDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
                // validate dateControl < currentDate
                if (c.value.setHours(0, 0, 0) < currentDate.setHours(0, 0, 0)) {
                    c.markAsTouched();
                    return ({ 'invalidTripInfoDate': true });
                } else {
                    return null;
                }
            }
        };
    }



    isValidWeekNumber(control: AbstractControl) {
        if (control.value < 0 || control.value > 1000) {
            return { 'invalidRange/0/1000': true };
        }
        return null;
    }

    updateTripInformationGroup(data, id, isMoveNextStep) {
        let url = ConsultationUrl.UPDATE_TRIP_INFORMATION_GROUP.replace('{groupConsultationId}', id);
        url += '?isMoveNextStep=' + isMoveNextStep;
        return this.baseService.postData(url, data);
    }

    updateTripInformation(data, id, isMoveNextStep) {
        let informationUrl = ConsultationUrl.UPDATE_TRIP_INFORMATION.replace('{consultationId}', id);
        informationUrl += '?isMoveNextStep=' + isMoveNextStep;
        return this.baseService.postData(informationUrl, data)
    }

    getRegionByCode(regionArr) {
        let param = '';
        regionArr.forEach(element => {
            param += (param !== '' ? '&' : '') + 'code=' + element;
        });
        const countryRegionUrl = MasterDataUrl.GET_COUNTRY_REGIONS + '?' + param;
        return this.baseService.getData(countryRegionUrl);
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-process/pop-up-summary-trip-information/pop-up-summary-trip-information.service.ts